<div data-at-schedule-box class="flex flex-col schedule">
  <div class="flex flex-row flex-[540px] max-h-[540px] min-h-[540px]">
    <div class="flex flex-col flex-[1_0_50px] min-w-[50px]">
      <ng-content select="app-program"></ng-content>
    </div>
  </div>
  <div class="schedule-overlay flex flex-row flex-[540px] max-h-[540px] min-h-[540px]">
    <div
      data-at-schedule-column
      class="flex flex-col justify-center items-center flex-[1_0_50px] min-w-[50px]"
      gtm="onOpen"
      gtmAction="Schedule editor"
      gtmCategory="editSchedule"
      (click)="editSchedule()"
    >
      <button mat-raised-button color="primary" class="edit-schedule">
        <mat-icon>border_color</mat-icon>
      </button>
    </div>
  </div>
</div>
